import { X } from "lucide-react";
import { useChatPanel } from "./ChatPanelContext";
import type { ChatPanelHeaderProps } from "./types";

export function ChatPanelHeader({ title, onClose }: ChatPanelHeaderProps) {
  const { closePanel } = useChatPanel();
  const handleClose = onClose ?? closePanel;

  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-border">
      <span className="text-sm font-semibold text-primary">{title}</span>
      <button
        type="button"
        onClick={handleClose}
        className="h-8 w-8 rounded-lg hover:bg-card flex items-center justify-center text-secondary hover:text-primary transition-colors cursor-pointer"
        aria-label="Close panel"
      >
        <X size={16} />
      </button>
    </div>
  );
}
